
import { defineComponent } from 'vue';
export default defineComponent({
	name: 'ReviewDetail',
	props: {
		name: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: true,
		}
	},
});
